function splitPhone(phone) {
  if (!phone) return { phone: '', code: '' };

  phone = String(phone);

  const splittedPhone = phone.substring(phone.length - 10, phone.length);
  const splittedNationCode = phone.substring(0, phone.length - 10);

  return { phone: splittedPhone, code: splittedNationCode };
}

export default splitPhone;
